export default "__VITE_ASSET__DBNyLW6m__"